export const DineIn = 'DineIn';
export const TakeAway = 'TakeAway';
